'use client';

import type { FC } from 'react';
import { useEffect, useLayoutEffect } from 'react';
import { useScreenLayout } from './useScreenLayout';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const ScreenTabBar: FC = () => {
  const { registerTabBarOverride, unregisterTabBarOverride } = useScreenLayout();

  useIsomorphicLayoutEffect(() => {
    registerTabBarOverride();
    return () => {
      unregisterTabBarOverride();
    };
  }, [registerTabBarOverride, unregisterTabBarOverride]);

  return null;
};
